import { ageLimitsSetupTour } from './ageLimitsSetupTour';
import { calendarSetupTour } from './calendarSetupTour';
import { dashboardSetupTour } from './dashboardSetupTour';
import { extrasSetupTour } from './extrasSetupTour';
import { insurancesSetupTour } from './insurancesSetupTour';
import { kmPoliciesSetupTour } from './kmPoliciesSetupTour';
import { seasonsSetupTour } from './seasonsSetupTour';
import { stationsSetupTour } from './stationsSetupTour';
import { vehicleGroupsSetupTour } from './vehicleGroupsSetupTour';
import { vehicleModelsSetupTour } from './vehicleModelsSetupTour';
import { vehiclesSetupTour } from './vehiclesSetupTour';
import type { SetupTourDefinition, SetupTourRegistry } from '../core/types';

export const setupTourRegistry = {
  vehicle_groups_setup: vehicleGroupsSetupTour,
  seasons_setup: seasonsSetupTour,
  stations_setup: stationsSetupTour,
  vehicle_models_setup: vehicleModelsSetupTour,
  vehicles_setup: vehiclesSetupTour,
  extras_setup: extrasSetupTour,
  insurances_setup: insurancesSetupTour,
  age_limits_setup: ageLimitsSetupTour,
  km_policies_setup: kmPoliciesSetupTour,
  dashboard_tour: dashboardSetupTour,
  calendar_tour: calendarSetupTour,
} as const satisfies SetupTourRegistry;

export type SetupTourId = keyof typeof setupTourRegistry;

export const getSetupTourDefinition = (id: SetupTourId): SetupTourDefinition =>
  setupTourRegistry[id];

export const getSidebarSetupTourTarget = (route?: string): string | undefined => {
  if (!route) return undefined;

  return Object.values(setupTourRegistry).find(
    ({ sidebarTargetsByRoute }) => sidebarTargetsByRoute?.[route],
  )?.sidebarTargetsByRoute?.[route];
};
